import React from 'react'
import * as media from "../../../../media";
import styled from "styled-components";
import Image from '../../../../basic/image'
import Checked from '../../../../static/checked.svg'
import Protected from '../../../../static/protected.svg'
import Settings from '../../../../static/settings.svg'
import GearImage from '../../../../static/gear.svg'
import {compose, lifecycle} from 'recompose'
import TranslateText from 'src/text/modal';


const Container = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin-top: 40px;
  margin-bottom: 40px;
  & .cover-image {
    max-width: 400px;
    max-height: 400px;
    background: rgb(235, 235, 235);
    padding: 20px;
  }
  ${media.smallerThan(1050)`flex-direction: column-reverse; align-items: center; & .cover-image { margin-top: 20px; }` }
`

const RightPanel = styled.div`
  flex-grow: 1;
  margin-left: 10%;
  width: 55%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
${media.smallerThan(1050)`
  width: auto;
  margin-left: 0;
  margin-bottom: 20px;
`}
`

const GearContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ul {
    padding-left: 24px;
  }
`

function Desktop({name, description, img, box, settingsText, protectedText, checkedText}) {
  return (
    <div style={{marginTop: 40}}>
      <p style={{fontSize: 24, fontWeight: 800}}>
        <TranslateText id={name} useTextImmitation={24} />
      </p>
      <p>{description}</p>
      <Container>
        <Image
          src={img}
          className="cover-image"
          containerStyle={{
            width: '35%',
            height: 430,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgb(235, 235, 235)',
          }}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
          }}
        />
        <RightPanel>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              padding: 20,
              paddingLeft: 40,
              border: '1px solid rgb(235, 235, 235)',
              height: 220,
            }}
          >
            <Image src={GearImage} containerStyle={{alignSelf: 'center', marginRight: 30}}/>
            <GearContainer>
              <TranslateText
                id={box}
                useHtml
                controls={['bold', 'ul']}
              />
            </GearContainer>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: 20,
              textAlign: 'center',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                flexDirection: 'column',
                flexGrow: 1,
                padding: 15,
                border: '1px solid rgb(235, 235, 235)',
                width: '30%',
                height: 190,
                wordBreak: 'break-word',
              }}
            >
              <Image
                src={Settings}
              />
              <div
                className={'hyphenate'}
                style={{marginTop: 10}}
              >
                <TranslateText id={settingsText}/>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                flexDirection: 'column',
                flexGrow: 1,
                marginLeft: '5%',
                padding: 15,
                border: '1px solid rgb(235, 235, 235)',
                width: '30%',
                height: 190,
                wordBreak: 'break-word',
              }}
            >
              <Image
                src={Protected}
              />
              <div className={'hyphenate'} style={{marginTop: 10}}>
                <TranslateText id={protectedText}/>
              </div>
            </div>
            <div
              className={'hyphenate'}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                flexDirection: 'column',
                flexGrow: 1,
                marginLeft: '5%',
                padding: 15,
                border: '1px solid rgb(235, 235, 235)',
                width: '30%',
                height: 190,
                wordBreak: 'break-word',
              }}
            >
              <Image
                src={Checked}
              />
              <div className={'hyphenate'} style={{marginTop: 10}}>
                <TranslateText id={checkedText}/>
              </div>
            </div>
          </div>
        </RightPanel>
      </Container>
    </div>
  )
}

const enhance = compose(
  lifecycle({
    componentDidUpdate() {
      setTimeout(() => {
        window.Hyphenator.run();
      }, 0)
    }
  }),
)

export default enhance(Desktop)


// WEBPACK FOOTER //
// ./src/finwhale/common/category/header/Desktop.js